// extracted by mini-css-extract-plugin
export default {"sa-allocation":"selling-agent-allocation_sa-allocation__iJW9T","button":"selling-agent-allocation_button__nmkkY"};